/**
 * Created by anthony on 6/28/14.
 */
var circularProgress = angular.module('circularProgress', []);
circularProgress.directive("circularprogress", function($parse){
    return {
        restrict: "E",
        scope: true,
        link: function(scope, element, attrs) {
            if (typeof attrs.buttonText === 'undefined') { attrs.buttonText = "'Save'"; }
            scope.$watch(attrs.buttonText, function () {
                if (typeof attrs.buttonText === 'undefined') { attrs.buttonText = "'Save'"; }
                scope.buttonText = $parse(attrs.buttonText)(scope);
            });
            var bttn = element[0].querySelector( '.progress-button' );
            new UIProgressButton( bttn, {
                callback : function( instance ) {
                    var params = { instance: instance };
                    instance.options.ajax( scope, params );
                    var progress = 0;
                    var interval = setInterval( function() {
                        if (progress != 1)
                        {
                            progress = Math.min( progress + Math.random() * instance.options.factor, 1 );
                            instance.setProgress( progress );
                        } else if (progress == 1 && typeof instance.options.status != 'undefined')
                        {
                            clearInterval( interval );
                            if ((instance.options.status == 200))
                            {
                                instance.stop(1);
                                instance.options.progressCompleteSuccess( scope, params );
                            }
                            else
                            {
                                instance.stop(-1);
                                instance.options.progressCompleteError( scope, params );
                            }
                            instance.options.status = undefined;
                        }
                    }, 350 );
                },
                ajax: $parse(attrs.ajax),
                factor: attrs.factor,
                progressCompleteSuccess : $parse(attrs.progressCompleteSuccess),
                progressCompleteError : $parse(attrs.progressCompleteError),
                callMe: function(data, status, headers, config, instance)
                {
                    instance.options.data = data;
                    instance.options.status = status;
                    instance.options.headers = headers;
                    instance.options.config = config;
                    instance.options.parent = parent;
                    instance.options.factor = .5;
                }
            } );

        },
        templateUrl: function(element, attr)
        {

            return 'ism-angular-lib/directives/circularProgressSubmit/' + attr.templateurl +'.html'
        }
    }
});